import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Kixie from './kixie-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Kixie {...validProps} />;
}
SvgComponent.iconName = 'kixie';

export const KixieIcon = svgIconWrapper(SvgComponent);
